import { ReactNode } from 'react';

import { AccordionContentProps, Content as RadixContent } from '@radix-ui/react-accordion';
import { twMerge } from 'tailwind-merge';

import Styles from './style.module.css';

interface SectionContentProps extends AccordionContentProps {
  readonly children: ReactNode;
  readonly className?: string;
}

function Content({ children, className, ...props }: SectionContentProps) {
  return (
    <RadixContent role="tabpanel" className={twMerge('px-4 pt-2', Styles.content, className)} {...props}>
      {children}
    </RadixContent>
  );
}

export { Content };
